export default __webpack_public_path__ + "sunset-94038dbc83a776d5bdf3b987b9f5e9f4.svg";